// extracted by mini-css-extract-plugin
module.exports = {"projectLinks":"ProjectLinks-module--projectLinks--1520k","title":"ProjectLinks-module--title--3zLqh Project-module--metatitle--2k2Se"};